export default {
  namespaced: true,
  policy_exception: {
    title: 'policy exception | policy exceptions',
    reference_number: 'Reference number',
    scope_type: 'Scope type',
    coverage: 'Coverage',
    scope: 'Scope',
    status: 'Status',
    request_type: 'Request type',
    assigned_to: 'Assigned to',
    in_review: 'In review',
    approved_canceled: 'Approved/Rejected',
    request_date: 'Request date',
    start_date: 'Start date',
    end_date: 'End date',
    regulatory_required: 'Regulatory required',
    regulation_description: 'Regulation description',
    exception_type: 'Exception type',
    source: 'Source',
    inherent_risk: 'Inherent risk',
    residual_risk: 'Residual risk',
    select_exception_type: 'Select exception type',
    select_status: 'Select status',
    select_source: 'Select source',
    select_inherent_risk: 'Select inherent risk',
    select_residual_risk: 'Select residual risk',
    units: 'Properties',
    unit: 'Unit',
    inmuebles: 'Properties',
    regions: 'Regions',
    created_from: 'Created from',
    created_to: 'Created to',
    validity_from: 'Validity from',
    validity_to: 'Validity to',
    municipalities: 'Municipalities',
    sectors: 'Sectors',
    standards: 'Standards',
    standards_affected: 'Standards affected',
    select_standards: 'Select standards',
    description: 'Exception description',
    compensatory_measures: 'Compensatory measures',
    justification: 'Exception justification',
    section_detail: 'Section/subsection detail of the standard',
    section_attachments: 'Section attachments',
    approver_soeid: 'Approver (SOEID)',
    attachments: 'Attach files',
    attachments_accepted_types: 'Images, PDF, Word, Excel, ZIP.',
    save_to_view_files: 'Save changes to view the files',
    pending_save: 'pending save',
    history: 'History',
    history_state: 'Status',
    history_user: 'User',
    history_date: 'Date',
    risk_level_table_level: 'Level',
    risk_level_table_description: 'Description',
    risk_table_title: 'Risk Table',
    show_risk_table: 'Show risk table',
    risk_level_critical: 'Critical',
    risk_level_critical_desc: 'Exceptions of non-compliance with Security Standards or Security Risks which, after factoring in compensating controls and mitigating factors, may potentially pose a critical risk where a facility is vulnerable to catastrophic security/safety or operational impact.',
    risk_level_high: 'High',
    risk_level_high_desc: 'Exceptions of non-compliance with Security Standards or Security Risks which, after factoring in compensating controls and mitigating factors, may potentially pose a significant risk to multiple facilities or processes, compromising security/safety or operational impact.',
    risk_level_medium: 'Medium',
    risk_level_medium_desc: 'Exceptions of non-compliance with Security Standards or Security Risks which, after factoring in compensating controls and mitigating factors, may potentially pose a moderate risk to a facility or process; compromising security/safety or operational impact.',
    risk_level_low: 'Low',
    risk_level_low_desc: 'Exceptions of non-compliance with Security Standards or Security Risks which, after factoring in compensating controls and mitigating factors, could have negligible adverse effect on a facility its operation and staff.',
    status_in_progress: 'In progress',
    status_in_review: 'In review',
    status_approved: 'Approved',
    status_rejected: 'Rejected',
    status_reassigned: 'Reassigned',
    status_canceled: 'Canceled',
    status_scheduled: 'Scheduled',
    nacional: 'National',
    select_scope_type: 'Select scope type',
    select_request_type: 'Select request type',
    select_units: 'Select properties',
    select_municipalities: 'Select municipalities',
    select_sectors: 'Select sectors',
    select_user: 'Select user',
    select_reviewer: 'Select reviewer',
    select_reviewer_first: 'Select a reviewer first',
    btn_send_to_review: 'Send to Review',
    unable_to_load: 'Unable to load policy exception.',
    one_required_field_missing: '1 required field is missing',
    multiple_required_fields_missing: '{count} required fields are missing',
    last_field: 'Last',
    comments: 'Comments',
    comments_placeholder: 'Optional comments',
    renew_exception: 'Renew Exception',
    close_exception: 'Close Exception',
    change_assignee: 'Change Assignee',
    close_reason: 'Close reason',
    close_exception_message: 'The form will become read-only and the exception will be closed.',
    close_reason_placeholder: 'Enter the reason for closing',
    start_date_must_be_after_request_date: 'Start date must be greater than or equal to request date',
    end_date_must_be_after_start_date: 'End date must be greater than or equal to start date',
    end_date_must_be_after_request_date: 'End date must be strictly greater than request date',
    conflict_inmuebles_in_progress: 'Property conflict',
    conflict_inmueble_in_policy: 'The property {unitLabel} is active in policy exception {referenceNumber} (type: {exceptionTypeName}).',
    workflow: {
      submit: 'Submit',
      approve: 'Approve',
      reject: 'Reject',
      cancel: 'Cancel',
      reassign: 'Reassign',
      submit_title: 'Submit for review',
      approve_title: 'Approve exception',
      reject_title: 'Reject exception',
      cancel_title: 'Cancel exception',
      reassign_title: 'Reassign to user',
      confirm_title: 'Confirm',
      submit_message: 'Submit this exception for review?',
      approve_message: 'Approve this policy exception?',
      reject_message: 'Reject this policy exception?',
      cancel_message: 'Cancel this policy exception?',
      confirm_message: 'Confirm this action for {ref}?',
    },
  },
}
